import actions from "./actions";

const initState = {
  tablesEfficiencyData: [],
  loading: false,
};

export default function tablesEfficiencyReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_TABLES_EFFICIENCY:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_TABLES_EFFICIENCY_SUCCESS:
      return {
        ...state,
        tablesEfficiencyData: action.tablesEfficiencyData,
        loading: false,
      };
    default:
      return state;
  }
}
